import React, { useEffect, useState } from "react";
import { Navbar, Row, Image } from "react-bootstrap";
import { List } from "react-bootstrap-icons";
import { useMsal } from "@azure/msal-react";
import { userlogo } from "../../helpers/formatter";
import { logout } from "../../services/user-service";
import { getActiveDepartments } from "../../services/department-service";
import logoutarrow from "../../assets/images/logoutarrow.svg"

export default function Header(props) {
  const { instance } = useMsal();

  async function handleLogout(instance) {
    try {
      await logout();
    } catch (error) {
      console.error("Logout API error:", error);
    }
    sessionStorage.clear();
    sessionStorage.setItem("isLoggingOut", "true");
    instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
  }

  const colors = ['#d9e3ee', '#f3d7d7', '#ebe4d5', '#d7f4f4', '#e0d5f1'];
  const fontcolors = ['#1A78E5', '#C64441', '#EDA70E', '#23B3B3', '#5D00F8'];
  const [randomColor, setRandomColor] = useState('');
  const [randomFontColor, setRandomFontColor] = useState('');
  const [deptName, setDeptName] = useState('Department');

  function getRandomInt(max) {
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    return array[0] % max;
  }

  useEffect(() => {
    const assignColor = getRandomInt(colors.length);
    const selectedColor = colors[assignColor];
    setRandomColor(selectedColor);
    const findFontColor = colors.findIndex(el => el === selectedColor);
    const selectedFontColor = fontcolors[findFontColor];
    setRandomFontColor(selectedFontColor);

    // Fetch department name
    const fetchDeptName = async () => {
      const deptId = sessionStorage.getItem('DeptId');
      if (deptId) {
        try {
          const departments = await getActiveDepartments();
          const dept = departments.find(d => d.DeptId === deptId);
          if (dept) {
            setDeptName(dept.Description);
          }
        } catch (error) {
          console.error('Failed to fetch department:', error);
        }
      }
    };
    fetchDeptName();
  }, []);

  const logoStyle = {
    background: `${randomColor} 0% 0% no-repeat padding-box`,
    color: `${randomFontColor}`
  };

  return (
    <Navbar bsPrefix="header">
      <div className="sidebar-head-header">
        <List className="head-toggle" onClick={() => { props.setSidebar(props.sidebar === "closed" ? "open" : "closed") }}></List>
      </div>
      <div className="app-name">Commercial Legal Website</div>
      <div className="user-section">
        <div className="user-info">
          <div className="user-logo" style={logoStyle}>
            <Row>
              {userlogo(sessionStorage.getItem("UserName"))}
            </Row>
          </div>
          <div>
            <Row>
              <span className="user-name">{sessionStorage.getItem("UserName")}</span>
            </Row>
            {/* <Row>
              <span className="user-email">{sessionStorage.getItem("Email")} </span>
            </Row> */}
            <Row>
              <span className="user-dept" style={{ fontSize: '12px', color: '#666' }}>Dept: {deptName}</span>
            </Row>
          </div>
          <div>
            <Image className="logout-image" src={logoutarrow} onClick={(e) => handleLogout(instance)}></Image>
          </div>
        </div>
      </div>
    </Navbar>
  );
}
